module.exports = __webpack_public_path__ + "img/logo.2af4a96d.png";